import type { TCompetency } from 'types/competency-profile'
import type { ReactElement } from 'react'

import PedagogikIcon from 'assets/icons/profil-kompetensi/img-chalk-board-teach-character-stundet.svg'
import KepribadianIcon from 'assets/icons/profil-kompetensi/img-heart-empathic-give-personalites-pink-allternatives.svg'
import ProfesionalIcon from 'assets/icons/profil-kompetensi/img-badge-star-ribbon-pro.svg'
import SosialIcon from 'assets/icons/profil-kompetensi/img-chat-talk.svg'

type CompetencyIcons = {
  [key in TCompetency]: ReactElement
}

export const CompetencyIcons: CompetencyIcons = {
  pedagogik: <PedagogikIcon />,
  kepribadian: <KepribadianIcon />,
  profesional: <ProfesionalIcon />,
  sosial: <SosialIcon />,
}
